import React from 'react'
import { connect } from 'react-redux'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import ta01 from '../../images/ta-01.png'
import ta02 from '../../images/ta-02.png'
import ta03 from '../../images/ta-03.png'
import ta0301 from '../../images/ta-03-01.png'
import ta0302 from '../../images/ta-03-02.png'
import ta0303 from '../../images/ta-03-03.png'
import ta0304 from '../../images/ta-03-04.png'
import ta04 from '../../images/ta-04.png'
import ta05 from '../../images/ta-05.png'
import ta06 from '../../images/ta-06.png'
import ta07 from '../../images/ta-07.png'
import ta08 from '../../images/ta-08.png'
import ta09 from '../../images/ta-09.png'
import { usersGetDetailAsync } from '../../actions/users.js'
import { Link } from 'react-router-dom'
import { getWeeklyDemoDataAsync } from '../../actions/global';
import { accesslog } from '../../helpers/global.js'

class TaNgac extends React.Component {
	constructor(props) {
		super(props);
	}

	async componentDidMount() {
    try {
      const urlParams = new URLSearchParams(this.props.location?.search);
      const utm_content = urlParams.get('utm_content');
      if (utm_content) {
        accesslog('nextgen-assessment-center', 'mount', { query: utm_content });
      }
    } catch (e) {}

		window.scrollTo(0, 0);
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync();
    }
  }

  render() {
    const { weeklyDemoData } = this.props

    return (
			<div id="ta-ngac">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="section-top-solution relative bg-gray" style={{
          position: 'relative',
          paddingTop: '120px',
        }}>
          <div className="gray-curve-bottom-left"></div>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <h1 className='title-1'>
                  NextGen Assessment Center
                </h1>
                <p className='sub-title-1'>
                  Smarter Assessments for Hiring and Talent Growth
                </p>
                <p className='text-normal-2'>
                  Evaluate talent with the depth of an assessment center—without the delays, paperwork, or scheduling issues. Whether you're identifying high potentials or hiring new candidates, ASTRNT’s NextGen Assessment Center brings structure, speed, and flexibility to every decision.
                </p>
                <a className='btn btn-primary-red' onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('nextgen-assessment-center', 'button_talk_to_an_expert');
                }}>
                  Talk to an Expert
                </a>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta01} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta02} />
              </div>
            </div>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <h1 className='title-2'>
                  Built for Talent Acquisition and Development
                </h1>
                <p className='sub-title-1'>
                  Traditional assessment centers often feel complex and hard to scale. ASTRNT simplifies the process without sacrificing depth or quality.
                </p>
                
                <p className='sub-title-1 m-t-25'>
                  Use it to:
                </p>
                <ul className='list-1'>
                  <li>
                    <div className=''>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Hire smarter</b>, especially for programs like graduate hiring, where placement and potential matter as much as qualifications
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Map internal talent</b> based on competencies, leadership readiness, and cultural fit
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Support succession planning</b> and internal mobility through clear, structured data
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <div className="curved-shape" style={{top:'1500px'}}></div>
        <div className="section-white" style={{overflow: 'hidden', position: 'relative'}}>
          <section className='flex-container' style={{zIndex: '2', position: 'relative'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <h1 className='title-2'>
                  What Makes It Different
                </h1>
                <ul className='list-1 m-t-20'>
                  <li>
                    <div>
                      <img src={ta0301} />
                      <p className='text-normal-1'>
                        <b>4x Faster Turnaround</b>
                        <p>Get detailed, competency-based reports in under 2 weeks</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <img src={ta0302} />
                      <p className='text-normal-1'>
                        <b>Lower Cost</b>
                        <p>Reduce logistics, travel, and coordination with our fully online, asynchronous process</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <img src={ta0303} />
                      <p className='text-normal-1'>
                        <b>More Accuracy</b>
                        <p>Use structured rubrics and assessor calibration to reduce bias and ensure consistency</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <img src={ta0304} />
                      <p className='text-normal-1'>
                        <b>Simple to Run</b>
                        <p>Skip the scheduling chaos—assessments and reviews happen when it works for everyone</p>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta03} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white center" style={{position: 'relative'}}>
          <h1 className='title-1' style={{position: 'relative', zIndex:'2'}}>
            Behind the NextGen Experience
          </h1>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center section-p-1'>
                <div>
                  <h1 className='title-2'>
                    Define Success Profiles
                  </h1>
                  <p className='sub-title-1'>
                    We start by building or refining your competency framework. It’s tailored by role, level, and business context.
                  </p>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta04} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center section-p-1'>
                <div>
                  <h1 className='title-2'>
                    Deliver Structured Assessments
                  </h1>
                  <p className='sub-title-1'>
                    Candidates respond to a mix of video, case, written, and situational tasks—all accessible from anywhere.
                  </p>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta05} />
              </div>
            </div>
          </section>
        </div>
        <div className="curved-shape-right" style={{top:'3130px'}}></div>
        <div className="section-white" style={{overflow: 'hidden', position:'relative'}}>
          <section className='flex-container' style={{zIndex: '2', position:'relative'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center section-p-1'>
                <div>
                  <h1 className='title-2'>
                    Score & Calibrate
                  </h1>
                  <p className='sub-title-1'>
                    Multiple assessors score using defined rubrics. Our platform supports calibration to ensure fair and aligned evaluation.
                  </p>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta06} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden', position:'relative'}}>
          <section className='flex-container' style={{zIndex: '2', position:'relative'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center section-p-1'>
                <div>
                  <h1 className='title-2'>
                    Receive Competency Reports
                  </h1>
                  <p className='sub-title-1'>
                    Get easy-to-read reports within two weeks, ready to support placement, development, or promotion decisions.
                  </p>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta07} />
              </div>
            </div>
          </section>
          <div className="red-curve-bottom-left"></div>
        </div>
        <div className="center" style={{
          backgroundColor:'#C04051', 
          overflow:'auto',
          padding: '40px 0',
        }}>
          <section>
            <div className='col-md-3'>
              <div className='horizontal-item--center'>
                <img src={ta08} width={278} height={428}/>
              </div>
            </div>
            <div className='col-md-9'>
              <h1 className='title-2' style={{color:'#fff'}}>
                Traditional vs NextGen
              </h1>
              <table className='table-1 m-t-30'>
                <tr>
                  <th className='col1'>Aspect</th>
                  <th className='col2'>Traditional Assessment</th>
                  <th className='col3'>NextGen by ASTRNT</th>
                </tr>
                <tr>
                  <td><b>Time to Complete</b></td>
                  <td>8 hours</td>
                  <td>3 hours</td>
                </tr>
                <tr>
                  <td><b>Scheduling</b></td>
                  <td>Heavy burden</td>
                  <td>Fully asynchronous</td>
                </tr>
                <tr>
                  <td><b>Report Turnaround</b></td>
                  <td>6-8 weeks</td>
                  <td>Less than 2 weeks</td>
                </tr>
                <tr>
                  <td><b>Scoring Consistency</b></td>
                  <td>Near impossible</td>
                  <td>Structured and calibrated</td>
                </tr>
              </table>
            </div>
          </section>
        </div>
        <div className="section-white bg-gray" style={{
          overflow: 'hidden',
        }}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={ta09} />
              </div>
            </div>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <h1 className='title-2'>
                  What You Can Assess
                </h1>
                <p className='sub-title-1'>
                  The NextGen Assessment Center supports multiple formats to capture how people think, solve, and lead.
                </p>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Job Simulations</b> for role readiness
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Behavioral & Situational Tasks</b> for decision-making and values alignment
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Case Study Analysis</b> for logical thinking and prioritisation
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Video Presentations</b> for communication and presence
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        <b>Group Exercises & Role Play</b> (optional, can be adapted digitally)
                      </p>
                    </div>
                  </li>
                </ul>
                <p className='text-normal-1'>
                  Need more flexibility? You can explore our full library of assessments including psychometric, technical, and language evaluations.
                </p>
                <a className='btn btn-primary-red' href='/assessments-and-interviews'
                  onClick={() => accesslog('nextgen-assessment-center', 'button_explore_assessment_interview')}
                >
                  Explore Assessments & Interviews
                </a>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white center"
          style={{
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
          }}
        >
          <div className='gray-triangle-bottom-right' style={{background:'#F7F7F7'}}>
            <div className='gray-small-triangle-bottom-right' style={{background:'#EDEDED'}}></div>
          </div>
          <div>
            <h1 className='title-1'>
              Make Every Assessment Count
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              Whether you’re hiring graduates or planning leadership transitions, ASTRNT brings clarity and speed to 
              <br />
              high-stakes decisions—without the old barriers.
            </p>
            <div>
              <a className='btn btn-primary-red' onClick={() => {
                document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                accesslog('nextgen-assessment-center', 'button_talk_to_an_expert');
              }} style={{margin:'0 10px 10px 0'}}>
                Talk to an Expert
              </a>
              <a className={`btn btn-secondary-red${weeklyDemoData.webinar_link != null ? '' : ' hide'}`} href={weeklyDemoData.webinar_link} target="_blank"
                style={{margin:'0 10px 10px 0'}}
                onClick={() => accesslog('nextgen-assessment-center', 'button_register_for_demo')}
              >
                Register for Demo
              </a>
            </div>
          </div>
        </div>
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData 
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaNgac)
